import Vue from 'vue'
import ApiService from '@/common/api.service'

export const state = {
  /*
   * simCardSelectionSets is a "grouping" of multiple SIM cards that are
   * selected. For example, one might wish to have a "global" set of
   * selected SIM cards that is persistent across all screens or one
   * might want to create a set of selected SIM cards for a particular
   * individual/group of widgets.
   */
  simCardSelectionSets: {}
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns the sets of selected SIM cards.
   *
   * @param state Object
   *
   * @return Object
   */
  simCardSelectionSets (state) {
    return state.simCardSelectionSets
  }
}

export const actions = {
  /**
   * Query/find one or more SIM cards.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  query (context, params) {
    return ApiService
      .get(`gdspo/sim-cards`, params)
      .then((response) => {
        return response
      })
  }
}

export const mutations = {
  /**
   * Add a map or array of object SIM cards that have been selected within
   * the specified set.
   *
   * @param state    Object
   * @param set      String
   * @param vehicles Array|Map
   */
  addSelectedSimCards (state, { set, simCards }) {
    if (!state.simCardSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.simCardSelectionSets, set, {})
    }

    simCards.forEach(simCard => {
      Vue.set(state.simCardSelectionSets[set], simCard.id, simCard)
    })
  },

  /**
   * Removes an array of SIM cards from the set's list of selected SIM cards.
   * The array must contain the list SIM cards that are no longer selected.
   *
   * @param state Object
   * @param set   String
   * @param SIM cards Array
   */
  removeSelectedSimCards (state, { set, simCards }) {
    if (state.simCardSelectionSets.hasOwnProperty(set)) {
      simCards.forEach(simCard => {
        Vue.delete(state.simCardSelectionSets[set], simCard.id)
      })
    }
  },

  /**
   * Clears all selected SIM cards.
   *
   * @param state Object
   */
  clearAllSelectedSimCards (state) {
    Vue.set(state, 'simCardSelectionSets', {})
  },

  /**
   * Clears all selected SIM cards within a specified set.
   *
   * @param state Object
   * @param set   String
   */
  clearSelectedSimCards (state, set) {
    if (state.simCardSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.simCardSelectionSets, set, {})
    }
  },

  /**
   * Purge the module's state.
   *
   * @param state Object
   */
  purge (state) {
    state.simCardSelectionSets = {}
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/sim-cards/gdspo/gdspoFindSimCardsWidgetModule.js